/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import product from "../../../../models/product";
// CSS
import "../../../../css/SelectOptionBtn.css";

let $ = window.$;
class Lv3SelectOptionBtn extends React.Component {
  getClass(defaultValue, itemCode) {
    return (
      (itemCode === defaultValue && "select blockBtn border-grey smaller") ||
      "blockBtn border-grey smaller"
    );
  }
  handleClick = e => {
    const { code, selectLv3Option, changeLv3SelectOptionDefault } = this.props;

    $(".outOfStockForm_wrap")
      .finish()
      .fadeOut();

    selectLv3Option(code);
    changeLv3SelectOptionDefault(code);
  };
  render() {
    const { name } = this.props;

    return (
      <a
        className="notAvailable blockBtn border-grey smaller"
        onClick={e => this.handleClick(e)}
      >
        <span className="notAvailable">{name}</span>
      </a>
    );
  }
}
const mapStateToProps = state => {
  return {
    lv3Default: state.product.lv3Default
  };
};

const mapDispatchToProps = () => {
  return {
    selectLv3Option: code => product.actions.selectLv3Option(code),
    changeLv3SelectOptionDefault: data =>
      product.actions.changeLv3SelectOptionDefault(data)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lv3SelectOptionBtn);
